export default {
    async runTests (runtime, terminalBus, code, tests, inputs = []) {
        let testResults = await runtime.test(code, tests, inputs);
        this.displayResults(testResults, terminalBus);

        return testResults.reduce((prev, { result }) => prev && result, true);
    },
    displayResults (testResults, terminalBus) {
        console.log(testResults);
        let tableContent = [
            ['Test', 'Oczekiwano', 'Otrzymano', 'Wynik'],
            ...testResults.map(test => [
                test.valueGenerator,
                test.expectedValue,
                (test.generatedValue !== undefined && test.generatedValue !== null) ? test.generatedValue.toString() : '-',
                test.result ? '\x1B[1;3;32mPozytywny\x1B[0m' : '\x1B[1;3;31mNegatywny\x1B[0m',
            ])
        ];

        terminalBus.$emit('writeMessage', '\n')
        terminalBus.$emit('writeMessage', 'Wyniki testów:\n')
        terminalBus.$emit('writeMessage', '\n')
        this.displayTable(tableContent, terminalBus);
    },
    displayTable (tableContent, terminalBus) {
        function displayableString(string, longestInColumn) {
            let spacesAfter = '';
            string = String(string);
            
            for (let i = 0; i < longestInColumn - (string.replace(/\x1B.*?m/g, '').length); i++) {
                spacesAfter += ' ';
            }

            return `${string}${spacesAfter}`;
        }

        function displayableRow(row, longest) {
            return row.reduce(
                (prev, col, index, whole) => prev + ` ${displayableString(col, longest[index])} ` + (index < whole.length - 1 ? '|' : ''),
                ''
            );
        }

        function separator(longest) {
            return longest.reduce((prev, longestInColumn, index, all) => {
                let colSeparator = '--';
                for (let i = 0; i < longestInColumn; i++) {
                    colSeparator += '-';
                }

                if (index < all.length - 1) {
                    colSeparator += '+';
                }

                return prev + colSeparator;
            }, '');
        }

        let longest = tableContent
            .map(row => row.map(val => new String(val).replace(/\x1B.*?m/g, '').length))
            .reduce((prev, current) => {
                for (let i = 0; i < current.length; i++) {
                    if (!prev[i] || prev[i] < current[i]) {
                        prev[i] = current[i];
                    }
                }

                return prev;
            });

        tableContent.forEach(row => {
            terminalBus.$emit('writeMessage', displayableRow(row, longest) + '\n');
            terminalBus.$emit('writeMessage', separator(longest) + '\n');
        })
    }
}
